import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimValue'
})
export class TrimValuePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    if (!value) return value;
    return value.trim();
  }

}
